import { render } from "./BaseLabel.vue?vue&type=template&id=6c79b30c&scoped=true"
import script from "./BaseLabel.js?vue&type=script&lang=js"
export * from "./BaseLabel.js?vue&type=script&lang=js"

import "./BaseLabel.scss?vue&type=style&index=0&id=6c79b30c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./BaseLabel.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2Fcomponents%2FBaseSelector%2FBaseLabel%2FBaseLabel.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c79b30c"]])

export default __exports__